import { PageType } from "../constants";
import { OnboardingError } from "./errors";
import { Programs } from "./programsConfig";

export enum AaaApplicationStep {
  Unset = "Aaa-Unset",
  GameInformation = "Aaa-GameInformation",
  ApplicationReadyForReview = "Aaa-ApplicationReadyForReview",
  ApplicationIsBeingReviewed = "Aaa-ApplicationIsBeingReviewed",
  ApplicationRejected = "Aaa-ApplicationRejected",
  ApplicationComplete = "Aaa-ApplicationComplete",
}

export const AaaApplicationStepsOrder = [
  AaaApplicationStep.Unset,
  AaaApplicationStep.GameInformation,
  AaaApplicationStep.ApplicationReadyForReview,
  AaaApplicationStep.ApplicationIsBeingReviewed,
  AaaApplicationStep.ApplicationComplete,
];

export enum IdXboxApplicationStep {
  Unset = "IdXbox-Unset",
  Introduction = "IdXbox-Introduction",
  IntroductionReadyToSubmit = "IdXbox-IntroductionReadyToSubmit",
  SoftApprovalDenied = "IdXbox-SoftApprovalDenied",
  NdaUnderReview = "IdXbox-NdaUnderReview",
  NdaSent = "IdXbox-NdaSent",
  GameInformation = "IdXbox-GameInformation",
  ApplicationReadyForReview = "IdXbox-ApplicationReadyForReview",
  ApplicationIsBeingReviewed = "IdXbox-ApplicationIsBeingReviewed",
  AdditionalAgreements = "IdXbox-AdditionalAgreements",
  ApplicationComplete = "IdXbox-ApplicationComplete",
}

export const IdXboxApplicationStepsOrder = [
  IdXboxApplicationStep.Unset,
  IdXboxApplicationStep.Introduction,
  IdXboxApplicationStep.IntroductionReadyToSubmit,
  IdXboxApplicationStep.SoftApprovalDenied,
  IdXboxApplicationStep.NdaUnderReview,
  IdXboxApplicationStep.NdaSent,
  IdXboxApplicationStep.GameInformation,
  IdXboxApplicationStep.ApplicationReadyForReview,
  IdXboxApplicationStep.ApplicationIsBeingReviewed,
  IdXboxApplicationStep.AdditionalAgreements,
  IdXboxApplicationStep.ApplicationComplete,
];

export enum PitchApplicationStep {
  Unset = "Pitch-Unset",
  NdaUnderReview = "Pitch-NdaUnderReview",
  NdaSent = "Pitch-NdaSent",
  PitchInformation = "Pitch-PitchInformation",
  ApplicationReadyForReview = "Pitch-ApplicationReadyForReview",
  ApplicationSubmitted = "Pitch-ApplicationSubmitted",
  ApplicationReviewed = "Pitch-ApplicationReviewed",
}

export const PitchApplicationStepsOrder = [
  PitchApplicationStep.Unset,
  PitchApplicationStep.NdaUnderReview,
  PitchApplicationStep.NdaSent,
  PitchApplicationStep.PitchInformation,
  PitchApplicationStep.ApplicationReadyForReview,
  PitchApplicationStep.ApplicationSubmitted,
  PitchApplicationStep.ApplicationReviewed,
];

export enum OnboardingProgram {
  AaaProgram = "AaaProgram",
  CreatorsProgram = "CreatorsProgram",
  IdXboxProgram = "IdXboxProgram",
  PitchProgram = "PitchProgram",
}

export type IdXboxStatusData = {
  step: {
    [Programs.IdXbox]: IdXboxApplicationStep;
    [Programs.Pitch]: PitchApplicationStep;
  };
  isInitialCrmFetchDone: { [programId: string]: boolean };
  isSavingForm: boolean;
  isSubmitting: boolean;
  currentError: undefined;
  currentProgram: Programs.IdXbox;
};

export type PitchStatusData = {
  step: {
    [Programs.IdXbox]: IdXboxApplicationStep;
    [Programs.Pitch]: PitchApplicationStep;
  };
  isInitialCrmFetchDone: { [programId: string]: boolean };
  isSavingForm: boolean;
  isSubmitting: boolean;
  currentError: undefined;
  currentProgram: Programs.Pitch;
};

export type UnsetStatusData = {
  step: {
    [Programs.IdXbox]: IdXboxApplicationStep.Unset;
    [Programs.Pitch]: PitchApplicationStep.Unset;
  };
  isInitialCrmFetchDone: { [programId: string]: boolean };
  isSavingForm: false;
  isSubmitting: false;
  isLoadingGameConcept: false;
  currentError: undefined;
  currentProgram: Programs.Unset;
  currentPageType: undefined;
};

export type StatusData = UnsetStatusData | IdXboxStatusData | PitchStatusData;

export type AnyStatusData = {
  step: {
    [Programs.IdXbox]: IdXboxApplicationStep;
    [Programs.Pitch]: PitchApplicationStep;
  };
  isInitialCrmFetchDone: { [programId: string]: boolean };
  isSavingForm: boolean;
  isSubmitting: boolean;
  isLoadingGameConcept: boolean;
  currentError: OnboardingError | undefined;
  currentProgram: Programs;
  currentPageType: PageType | undefined;
};

export enum ContractStatus {
  Executed = "Executed",
  PendingSignature = "PendingSignature",
}

export enum NdaStatus {
  Unset = "Unset",
  Sent = "Sent",
  Signed = "Signed",
}
